import React from 'react';
import { DataProvider, Urls } from '../Data';
import { StaffRoot } from './Root';
import { HashSelect } from './HashSelect';

type ConfigProps = {
  urls: Urls
  lang: string
}

export function StaffConfig({ urls, lang }: ConfigProps) {
  const _lang = lang === 'de' ? 'de' : 'en';
  return (
    <DataProvider urls={urls} lang={_lang} needs={['users', 'positions', 'buildings', 'floors']}>
      <HashSelect />
      <StaffRoot />
    </DataProvider>
  );
}
